<div class="wp-wrapper">
  <div class="wp-detail">
    <div class="theme m-b-10">
      <p-chip
        class="theme m-b-15"
        ngbTooltip="Driving Access Initiatives To Shape Healthcare Systems"
      >
        <span
          class="theme-color"
          [style]="{ background: 'rgb(100, 47, 192)' }"
        ></span>
        <span class="title b3 text-80 lh-2-0">
          Driving Access Initiatives To Shape Healthcare Systems
        </span>
      </p-chip>
    </div>
    <div class="">
      <div class="wp-name b1 text-90"> {{ wp?.workpackage?.name || "N/A" }}</div>
      <div class="wp-desc m-b-15 m-t-5">
        <div class="b3 text-60">(Description: {{ wp?.workpackage?.description || "N/A" }})</div>
      </div>
      <div class="wp-content dis-flex flex-row flex-sb">
        <div class="dis-flex">
          <div>
            <p class="field-title caption text-60 m-b-0">Area of Impact</p>
            <p class="b3 font-medium text-80 m-b-0">{{ wp?.workpackage?.area_of_impact || "N/A" }}</p>
          </div>
          <p-divider class="vertical-divider" layout="vertical" />
          <div class="dis-flex">
            <div class="m-r-20">
              <p class="field-title caption text-60 m-b-0">Owner</p>
              <p-avatar
                class="p-avatar-square"
                [image]="helper.defaultImageUrl"
                [ngbTooltip]="wp?.owner?.name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <button class="btn success b2" (click)="openApprovalModal()">
      <ng-icon
        class="m-r-5 lh-1-0"
        size="18"
        name="hugeCheckmarkCircle04"
      />Approve
    </button>
  </div>
</div>
<p-dialog
  header="Approve?"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="isApproval"
  [style]="{ width: '30rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <div class="dis-flex flex-col">
      <p class="b2 m-b-0 text-70">
        Are you sure, you want to
        <span class="font-medium text-80">Approve</span>?
      </p>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10" (click)="closeApprove()">
      Cancel
    </button>
    <button class="btn delete wd-100px" (click)="onApprove(wp?.approval_id)">Approve</button>
  </div>
</p-dialog>

